<!--  -->
<template>
  <div class="all_box">
    <div class="allitem_box">
      <div v-if="type !== 2" class="task_box">
        <div class="tewr_text">任务名称：</div>
        <el-input v-model="taskinput" style="" placeholder="任意填写，用于自己识别，不要超过20字" />
      </div>
      <div v-if="type !== 2" class="task_box" style="margin-top: 20px;">
        <div class="tewr_text">选公众号：</div>
        <el-tag v-if="id!==null" style="margin-right:10px">{{ name }}</el-tag>
        <el-tag type="warning" @click="choose">选择公众号</el-tag>
      </div>
      <!-- <div class="task_box seser">
        <div class="tewr_text">群发对象：</div>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in optionsr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div> -->
      <div v-if="type !== 2" class="task_box seser">
        <div class="tewr_text">选择模板：</div>
        <el-select v-model="templatevalue" :disabled="id===null" style="width:300px" placeholder="请先选择公众号" @change="processTemplate">
          <el-option
            v-for="item in option"
            :key="item.template_id"
            :label="item.template_title"
            :value="item.template_id"
          />
        </el-select>
      </div>
      <div v-if="templatevalue!=''" class="query_allbox">
        <div v-for="(item,index) in arr" :key="index" class="query_input">
          <div class="quert_textr">{{ item.title }}</div>
          <el-input
            v-model="item.value"
            type="textarea"
            autosize
            placeholder="请输入内容"
            @blur="handleInputBlur"
          />
          <div v-if="item.key.indexOf('keyword') != -1" class="warning-font">请输入小于等于20个字符</div>
          <div v-if="item.key.indexOf('first') != -1" class="warning-font">请输入小于等于20个字符</div>
          <div v-if="item.key.indexOf('remark') != -1" class="warning-font">请输入小于等于20个字符</div>
          <div style="margin-right: 5px;" />
          <!-- <el-color-picker v-model="item.color" style="margin:0px 5px;" @change="item.color = $event" /> -->
          <el-popover
            placement="right"
            width="400"
            trigger="click"
          >
            <div style="display:flex;flex-wrap:wrap">
              <div v-for="(items,idx) in emoji_icon" :key="idx" @click="itemclaickw(index,idx)">
                {{ items }}
              </div>
            </div>
            <i slot="reference" class="el-icon-info" />
          </el-popover>
        </div>

        <!-- <div class="tit">公众号选择：</div>
        <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 10px 0;" />
        <el-checkbox-group v-model="checkedName" @change="handleCheckedNameChange">
          <el-checkbox v-for="(item,index) in official" :key="index" :label="item.app_id" style="margin-right:15px">{{ item.account_name }}</el-checkbox>
        </el-checkbox-group> -->
      </div>
      <div class="task_box seser">
        <div class="tewr_text">点击跳转：</div>
        <el-radio-group v-model="radio">
          <el-radio :label="1">链接</el-radio>
          <el-radio :label="2">小程序</el-radio>
        </el-radio-group>
      </div>
      <div v-if="radio == 1 && switchvalue == 2" class="task_box seser">
        <div class="tewr_text">跳转链接：</div>
        <el-input v-model="link" style="" placeholder="用户点击模板后跳转到的网页链接" />
      </div>
      <div v-if="radio == 1 && switchvalue == 1" class="task_box seser" style="display:none">
        <div class="tewr_text">跳转链接：</div>
        <el-input v-model="generatedUrl" disabled style="" placeholder="用户点击模板后跳转到的网页链接" />
      </div>
      <div v-if="radio == 1" class="task_box seser">
        <div class="tewr_text">h5跳小程序：</div>
        <el-switch
          v-model="switchvalue"
          style="display: block"
          :disabled="type==2"
          :active-value="1"
          :inactive-value="2"
          active-text="开"
          inactive-text="关"
          @change="chanswitch"
        />
      </div>
      <div v-if="radio == 1 && switchvalue == 1" class="task_box seser">
        <div class="tewr_text">appid：</div>
        <el-input v-model="app_ids" style="" placeholder="小程序appid（小程序务必授权在运营系统）" @blur="removeAllSpaces" />
      </div>
      <div v-if="radio == 1 && switchvalue == 1" class="task_box seser">
        <div class="tewr_text">链接：</div>
        <el-input v-model="path" style="" placeholder="小程序跳转路径path" @blur="removeAllSpacestwo" />
      </div>
      <div v-if="radio == 2" class="tip">
        <span style="margin-right:3px">*</span>
        <span>请在发送前确保所选公众号已关联此小程序</span>
      </div>
      <div v-if="radio == 2" class="task_box seser">
        <div class="tewr_text">APPID：</div>
        <el-input v-model="app_id" style="" placeholder="请输入appid" />
      </div>

      <div v-if="radio == 2" class="task_box seser">
        <div class="tewr_text">页面路径：</div>
        <el-input v-model="linkpath" style="" placeholder="请输入页面路径" />
      </div>
      <div class="task_box seser">
        <div class="tewr_text">发送时间：</div>
        <!-- <el-radio-group v-model="timeradio">
          <el-radio :label="1">立即发送</el-radio>
          <el-radio :label="2">定时发送</el-radio>
        </el-radio-group> -->
        <el-date-picker
          v-model="value1"
          type="datetime"
          placeholder="选择日期时间"
          :clearable="false"
          :picker-options="{disabledDate: (time) =>time.getTime() <new Date(new Date().setHours(0, 0, 0, 0))}"
        />
      </div>
      <!-- <div v-if="timeradio == 2" class="task_box seser">
        <div class="tewr_text">定时发送：</div>
      <el-date-picker
        v-model="value1"
        type="datetime"
        placeholder="选择日期时间"
        :clearable="false"
        :picker-options="{disabledDate: (time) =>time.getTime() <new Date(new Date().setHours(0, 0, 0, 0))}"
      />
      </div> -->
      <div v-if="type!=2" class="task_box seser">
        <div class="tewr_text" />
        <el-button type="primary" @click="save(false)">确定</el-button>
        <el-button type="success" @click="save(true)">预览</el-button>
      </div>
    </div>
    <div v-if="type!==2">
      <div class="phone_box">
        <div class="phone_content">
          <div>{{ choosetaskinput }}</div>
          <div class="phone_data">{{ getCurrentTime() }}</div>
          <div class="phone_contentse">
            <div v-for="(itemw,idxr) in arr" :key="idxr" class="phone_item">
              {{ itemw.title }}<span :style="`color:${itemw.color}`">{{ itemw.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择公众号"
      :visible.sync="choicedialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
    >
      <chooseaccount ref="wecawr" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import { templateList, /* appIdByTemplateTitle */ store /* oneTemplate */ } from '@/api/numberTemplatemessage.js'
import emojiicon from '../../customerService/js/expression.js'
import chooseaccount from '../../risktesting/components/chooseaccount.vue'
export default {
  components: { chooseaccount },
  data() {
    return {
      taskinput: '',
      value: '',
      templatevalue: '',
      optionsr: [{
        value: 1,
        label: '全部用户'
      }],
      option: [],
      arr: [],
      choosetaskinput: '',
      emoji_icon: emojiicon.emoji_icon, // 表情
      blurIndex: null,
      radio: 1,
      link: '',
      app_id: '',
      title: '',
      linkpath: '',
      timeradio: 2,
      value1: '',
      obj: {
        page: 1,
        page_size: 100
      },
      checkedName: [],
      official: [],
      checkAll: false,
      isIndeterminate: true,
      name: '',
      id: null,
      choicedialogVisible: false,
      template_title: '',
      rewrw: /keyword(.*?)(?=[\]\},])/g,
      type: null,
      switchvalue: 2,
      app_ids: '',
      path: '',
      apiUrl: process.env.VUE_APP_BACKUP_API_URL.replace('api', ''),
      generatedUrl: '',
      alllink: ''
    }
  },
  // computed: {
  //   generatedUrl() {
  //     return `${this.link}${this.app_id}?path=${this.path}`;
  //   }
  // },
  watch: {
    // 监听 link、app_id 和 path 的变化
    link() {
      this.updateGeneratedUrl()
    },
    app_ids() {
      this.updateGeneratedUrl()
    },
    path() {
      this.updateGeneratedUrl()
    }
  },
  created() {
    // this.getTemplateList()
    this.updateGeneratedUrl()
  },
  mounted() {

  },
  methods: {
    updateGeneratedUrl() {
      this.generatedUrl = `${this.link}${this.app_ids}?path=${this.path}`
    },
    isFieldContainsString(key) {
      console.log(key, !key.match(this.rewrw))
      return !key.match(this.rewrw)
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    async getTemplateList() {
      const data = await templateList({ ...this.obj, app_id: this.id })
      this.option = data.data.list
      console.log('this.option', this.option)
    },

    // 处理模版
    async processTemplate(index) {
      // const datas = await oneTemplate(
      //   { template_title: index })
      // const newArr = datas.data.content
      // newArr.forEach((item) => {
      //   // this.$set(item, 'color', '')
      //   this.$set(item, 'value', '')
      // })
      // this.arr = newArr
      console.log('index', index)
      for (let i = 0; i < this.option.length; i++) {
        if (this.option[i].template_id === index) {
          const newArr = this.option[i].content
          this.template_title = this.option[i].template_title
          newArr.forEach((item) => {
            // this.$set(item, 'color', '')
            this.$set(item, 'value', '')
          })
          this.arr = newArr
        }
      }
    },
    itemclaickw(index, idx) {
      this.arr[index].value = this.arr[index].value.slice(0, this.blurIndex) + this.emoji_icon[idx] + this.arr[index].value.slice(this.blurIndex)
      // this.arr[index].textarea += this.emoji_icon[idx]
    },
    getCurrentTime() {
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      return mm + '月' + dd
    },
    // 验证消息
    verification() {
      for (const key in this.arr) {
        const item = this.arr[key]
        console.log('key', key, 'item', item)
        // eslint-disable-next-line eqeqeq
        if (!item.value) {
          this.$message({
            message: '模版消息不能为空',
            type: 'warning'
          })
          return false
        }
        // eslint-disable-next-line eqeqeq
        if (item.key.indexOf('keyword') != -1 && item.value.length > 20) {
          this.$message({
            message: `${item.title}不能超过20个字符`,
            type: 'warning'
          })
          return false
        }
        // eslint-disable-next-line eqeqeq
        if (item.key.indexOf('remark') != -1 && item.value.length > 20) {
          this.$message({
            message: `${item.title}不能超过20个字符`,
            type: 'warning'
          })
          return false
        }
        // eslint-disable-next-line eqeqeq
        if (item.key.indexOf('first') != -1 && item.value.length > 20) {
          this.$message({
            message: `${item.title}不能超过20个字符`,
            type: 'warning'
          })
          return false
        }
      }

      return true
    },
    choose() {
      this.choicedialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.wecawr.send()
      }, 100)
    },
    callback(item) {
      this.choicedialogVisible = false
      this.name = item.account_name
      this.id = item.app_id
      this.option = []
      this.templatevalue = ''
      this.template_title = ''
      this.arr = []
      this.getTemplateList()
    },
    async save(preview) {
      if (this.taskinput === '') {
        this.$message.error('请输入任务名称')
        return
      }
      if (this.taskinput.length > 20) {
        this.$message.error('请输入任务名称不能超过20字')
        return
      }
      // if (this.value === '') {
      //   this.$message.error('请选择群发对象')
      //   return
      // }
      if (this.templatevalue === '') {
        this.$message.error('请选择模板')
        return
      }
      // if (this.checkedName.length === 0) {
      //   this.$message.error('请选择公众号')
      //   return
      // }
      if (this.radio === 1) {
        if (this.link === '') {
          this.$message.error('请输入跳转链接')
          return
        }
      }
      console.log('this.switchvalue', this.switchvalue)
      if (this.radio === 1 && this.switchvalue === 1) {
        if (this.link === '') {
          this.$message.error('请输入跳转链接')
          return
        }
        if (this.app_ids === '') {
          this.$message.error('请输入appid')
          return
        }
        if (this.startsWithWx(this.app_ids) === false) {
          this.$message.error('请输入正确的appid')
          return
        }
        if (this.path === '') {
          this.$message.error('请输入地址')
          return
        }
      }
      if (this.radio === 2) {
        if (this.app_id === '') {
          this.$message.error('请输入APPID')
          return
        }
        if (this.linkpath === '') {
          this.$message.error('请输入页面路径')
          return
        }
      }
      if (this.timeradio === '') {
        this.$message.error('请选择发送时间')
        return
      }
      if (this.timeradio === 1) {
        this.value1 = new Date()
      }
      if (this.timeradio === 2) {
        // eslint-disable-next-line eqeqeq
        console.log('preview', preview)
        if (this.value1 === '' && !preview) {
          this.$message.error('请选择发送时间')
          return
        }
      }
      const time = new Date()
      // eslint-disable-next-line eqeqeq
      if (time >= this.value1 && !preview) {
        this.$message.error('请选择发送日期时间不得早于当前时间')
        return
      }
      if (this.verification()) {
        // console.log('data', this.taskinput,
        //   this.templatevalue,
        //   this.arr,
        //   this.link, this.linkpath,
        //   this.timeradio,
        //   this.radio,
        //   this.value1,
        //   this.checkedName,
        //   this.app_id)
        this.alllink = ''
        if (this.radio === 1) {
          if (this.switchvalue === 1) {
            this.alllink = `${this.link}${this.app_ids}?path=${btoa(this.path)}`
          } else {
            this.alllink = this.link
          }
        } else {
          this.alllink = this.linkpath
        }
        const data = await store({
          title: this.taskinput,
          template_id: this.templatevalue,
          template_title: this.template_title,
          variable_value: this.arr,
          // jump_link: this.radio === 1 ? this.link : this.linkpath,
          jump_link: this.alllink,
          send_type: this.timeradio,
          jump_type: this.radio,
          send_time: this.value1,
          app_ids: [this.id],
          app_id: this.app_id,
          preview: preview
        })

        if (data.code === 200) {
          console.log('this.type', this.type, preview)
          // eslint-disable-next-line eqeqeq
          if (preview) {
            this.$message({
              message: '预览成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('creatsuccessclose')
          }
        }
      }
    },
    startsWithWx(str) {
      // 使用正则表达式检查字符串是否以 "wx" 开头
      const regex = /^wx/
      return regex.test(str)
    },
    handleCheckAllChange(val) {
      console.log('val', val)
      console.log('val---', this.official)
      const newOffical = []
      for (var i = 0; i < this.official.length; i++) {
        newOffical.push(this.official[i].app_id)
      }
      this.checkedName = val ? newOffical : []
      this.isIndeterminate = false
    },
    handleCheckedNameChange(value) {
      console.log('value.length', value.length)
      const checkedCount = value.length
      this.checkAll = checkedCount === this.official.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.official.length
    },
    edit(item, type) {
      console.log('1111', item.send_time_text)
      this.type = type
      this.templatevalue = item.template_id
      this.arr = JSON.parse(item.variable_value)
      this.radio = item.jump_type
      this.value1 = null
      this.value1 = item.send_time_text

      // eslint-disable-next-line eqeqeq
      if (item.jump_type == 1) {
        // this.link = item.jump_link
        // 判断 URL 是否包含 'externalAddress'
        if (item.jump_link.includes('externalAddress')) {
          console.log("URL 包含 'externalAddress'。")
          // 解析 URL
          const urlObj = new URL(item.jump_link)
          // 提取 ID
          const id = urlObj.pathname.split('/').pop() // 提取 ID
          // 获取 path 参数
          const base64Path = urlObj.searchParams.get('path') // 获取 path 参数
          // 将 Base64 转换为正常字符串
          const decodedPath = decodeURIComponent(atob(base64Path))
          console.log('ID:', id) // 输出: ID: 12
          console.log('Decoded Path:', decodedPath) // 输出: 解码后的路径
          // this.$set(item, 'app_id', id)
          // this.$set(item, 'path', decodedPath)
          // this.$set(item, 'switch', 1)
          // this.$set(item, 'content_source_url', `${this.apiUrl}externalAddress/`)
          this.switchvalue = 1
          this.link = `${this.apiUrl}externalAddress/`
          this.app_ids = `${id}`
          this.path = `${decodedPath}`
          this.updateGeneratedUrl()
          // this.link = `${this.apiUrl}externalAddress/${id}?path=${decodedPath}`
        } else {
          console.log("URL 不包含 'externalAddress'。")
          this.link = item.jump_link
        }
      } else {
        this.app_id = item.app_id
        this.linkpath = item.jump_link
      }
    },
    chanswitch(val) {
      console.log('val', val)
      if (val === 1) {
        this.link = `${this.apiUrl}externalAddress/`
      } else {
        this.link = ''
      }
    },
    removeAllSpaces() {
      // 去掉输入值中的所有空格
      this.app_ids = this.app_ids.replace(/\s+/g, '')
    },
    removeAllSpacestwo() {
      this.path = this.path.replace(/\s+/g, '')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.task_box{
  display: flex;
  align-items: center;
  width:100p
}
.seser{
  margin-top: 20px;
}
.all_box{
  padding-right: 50px;
  display: flex;
  justify-content: space-between;
}
.phone_box{
  background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
  background-size: 100% 100%;

  height: 600px;
  margin-left: 100px;
  position: relative;
}
.phone_content{
  width: 240px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
  padding: 10px 25px 14px 11px;
  box-sizing: border-box;
}
.phone_data{
  color: #d1dfff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.phone_item{
  margin-bottom: 10px;
}
.allitem_box{
  /* margin-right: 50px; */
}
.tewr_text{
  width: 90px;
}
.query_input{
  background: #f5f5f5;
  width: 700px;
  display: flex;
  align-items: center;
  padding: 13px;
}
.query_allbox{
  margin-top: 20px;
  margin-left:10px;
}
.quert_textr{
  width: 100px;
  flex-shrink: 0;
  margin-right: 10px;
}
.tit{
  margin:10px 0;
}
.tip{
  margin-top:15px;
  color:red;
}
.warning-font{
  margin-left: 10px;color: #F56C6C;
}
@media (max-width: 768px) {
  .query_input{
    width:330px;
  }
  .warning-font{
    font-size:2vw !important;
  }
}
</style>
